module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_GreatIcosahedron.8c083643.png";